import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { CommonService } from './common.service';
import jwtDecode, { JwtPayload } from "jwt-decode";
import { User } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private cookie: CookieService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  login(userId: string, password: string ){
    return this.http.post<any>(this.commonService.apiUrl + '/login', { userId: userId , password: password})
  }
  adminLogin(userId: string, token: string){
    let headers = new HttpHeaders({
      "Authorization" : "Bearer " + token
    })
    return this.http.post<any>(this.commonService.apiUrl + '/admin/login', { userId: userId}, {headers : headers})
  }
  refreshToken() {
    let accessToken = this.getAccessToken();
    let refreshToken = this.commonService.getUserInfo().refreshToken
    //console.log("######called refreshToken accessToken : " + accessToken)
    //console.log("######called refreshToken refreshToken : " + refreshToken)
    return this.http.post<any>(this.commonService.apiUrl + '/refreshToken', { accessToken: accessToken, refreshToken: refreshToken, type: "CMS"})
  }

  saveToken(accessToken: string, refreshToken: string): void {
    var jwtPayload = jwtDecode<any>(accessToken);
    this.cookie.set('accessToken', accessToken, undefined, "/")
    let user = new User()
    user.userId = jwtPayload.sub
    user.userNo = jwtPayload.userNo
    user.userName = jwtPayload.userName
    user.roles = jwtPayload.roles
    user.status = jwtPayload.status
    user.userGrade = jwtPayload.userGrade
    if(user.userGrade == 'G1') {
      user.userGradeName = '이웃등급'
    } else if (user.userGrade == 'G2') { 
      user.userGradeName = '파워등급'
    } else {
      user.userGradeName = '미설정'
    }
    if(user.roles.indexOf('ROLE_USER') > -1) {
      user.isUser = true
    }
    if(user.roles.indexOf('ROLE_ADMIN') > -1) {
      user.isAdmin = true
    }
    if(user.roles.indexOf('ROLE_FINANCE') > -1) {
      user.isFinance = true
    }
    user.refreshToken = refreshToken
    this.cookie.set('userInfo', this.commonService.encryption(JSON.stringify(user)), undefined, "/")
  }

  //token 가져오기
  checkAccessToken(): boolean {
    const token = this.cookie.get('accessToken')
    if (token == null || token.length < 1) {
      return false;
    } else {
      return true;
    }
  }

  getAccessToken(): string {
    return this.cookie.get("accessToken")
  }
  checkAccessTokenValid(): boolean {
    try {
      var jwtPayload = jwtDecode<any>(this.getAccessToken());
      if (Date.now() >= jwtPayload.exp * 1000) {
        return false
      } else {
        return true
      }
    } catch (error) {
      return false
    }
  }

  logout(){
    this.cookie.delete("accessToken", "/")
    this.cookie.delete("userInfo", "/")
    window.location.href = '/login'
    //this.router.navigate(['/login'])
  }
}
